import { CombinedCandidatesFeatureActionTypes } from "..";
import { CandidateState } from "../candidateState";
import { uiActionCreator } from "./uiActionTypes";

export const useUIActions = (
    state: CandidateState,
    dispatch: React.Dispatch<CombinedCandidatesFeatureActionTypes>
) => {
    return {
        setSelectedLeadTab: (tab: string) =>
            dispatch(uiActionCreator.setSelectedLeadTab(tab)),
        clearError: () => dispatch(uiActionCreator.clearError()),
    };
};

export type UIActions = ReturnType<typeof useUIActions>;
